<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card title="Master User">
      <!-- <b-card-text>User.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Company -->
            <b-col cols="12">
              <b-form-group
                label="Company"
                label-for="v-company"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Company"
                  rules="required"
                >
                  <v-select
                    id="v-company"
                    v-model="form.company"
                    placeholder="Choose Company"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="companyOptions"
                    :reduce="v => v.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Project -->
            <b-col cols="12">
              <b-form-group
                label="Project"
                label-for="v-project"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Project"
                  rules="required"
                >
                  <v-select
                    id="v-project"
                    v-model="form.projects"
                    placeholder="Choose Project"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    multiple
                    :options="projectOptions"
                    :reduce="v => v.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Role -->
            <b-col cols="12">
              <b-form-group
                label="Role"
                label-for="v-Role"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <v-select
                    id="v-Role"
                    v-model="form.select_2"
                    placeholder="Choose Role"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="roleOptions"
                    :reduce="roleOptions => roleOptions.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group
                label="Name"
                label-for="v-user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    id="v-Name"
                    v-model="form.text_1"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Email -->
            <b-col cols="12">
              <b-form-group
                label="Email"
                label-for="v-user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="v-Email"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Password -->
            <b-col cols="12">
              <b-form-group
                label="Password"
                label-for="v-user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-form-input
                    id="v-Password"
                    v-model="form.text_3"
                    type="password"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Password"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Phone -->
            <b-col cols="12">
              <b-form-group
                label="Phone"
                label-for="v-user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  rules="required"
                >
                  <b-form-input
                    id="v-Phone"
                    v-model="form.text_4"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Phone"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
  },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, company: '', projects: [], select_2: '', checkbox_1: '', text_1: '', text_2: '', text_3: '', text_4: '', text_5: '',
      },
      show: false,
      required,
    }
  },
  computed: {
    ...mapState({
      roleOptions: state => state.role.options,
      companyOptions: state => state.company.options,
      projectOptions: state => state.project.options,
    }),
  },
  created() {
    this.$store.dispatch('role/getAll')
    this.$store.dispatch('company/getAll')
    this.$store.dispatch('project/getAll')
  },
  mounted() {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  },
  methods: {
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.form
            this.$store.dispatch('user/formPostPut', formData)
              .then(res => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                this.show = false
                this.resetForm()
              },
              err => {
                const errMsg = err || 'You have unsuccessful'
                this.show = false
                this.notification('Failed', 'CloseIcon', 'danger', errMsg)
              })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    resetForm() {
      this.$refs.simpleRules.reset()
      this.form = {
        id: null, company: '', projects: [], select_2: '', checkbox_1: '', text_1: '', text_2: '', text_3: '', text_4: '', text_5: '',
      }
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    getData(id) {
      this.$store.dispatch('user/getById', id).then(data => {
        this.form.id = data.id
        this.form.company = data.company_id
        this.form.select_2 = data.role_id
        this.form.text_1 = data.name
        this.form.text_2 = data.email
        this.form.text_3 = data.password
        this.form.text_4 = data.phone
        this.show = false
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
